import React, { useState } from 'react'
import { Button, Input, Modal, ModalBody, ModalFooter } from 'reactstrap'
import { ZodError } from 'zod'
import { Z_FightData } from '../../redux/models'
import { useAppDispatch } from '../../redux/redux-hooks'
import { ModalsActions } from '../../redux/slices/modals-slice'
import { ViewTimelineActions } from '../../redux/slices/view-timeline-slice'

export const IMPORT_MODAL = "IMPORT_MODAL"

export type ImportModalProps = {}

export const ImportModal = (props: ImportModalProps): JSX.Element | null => {

    const appDisp = useAppDispatch()
    const closeSelf = () => appDisp(ModalsActions.popModal())

    const [state, setState] = useState('')

    return (
        <Modal
            isOpen={true}
            fade={false}
            size="lg"
            toggle={closeSelf}
        >

            <ModalBody>
                <Input
                    style={{
                        minHeight: 500
                    }}
                    value={state}
                    type="textarea"
                    onChange={(e) => {
                        setState(e.target.value)
                    }}
                />
            </ModalBody>

            <ModalFooter className="d-flex justify-content-end">
                <div className="d-flex space-mx-2">
                    <Button onClick={() => {
                        if (state !== '') {
                            try {

                                // Notice: this data HAS to be cloned
                                // before written to satet., otherwise
                                // the IDs in here will go haywire if
                                // we import the same export twice.
                                const fightData = Z_FightData.parse(JSON.parse(state))
                                appDisp(ViewTimelineActions.cloneGivenFight({ fightData }))

                                closeSelf()

                            } catch (error) {
                                if (error instanceof ZodError) {
                                    setState(`Parse error: ${JSON.stringify(error.issues, null, ' ')}`)
                                } else {
                                    setState(`Unkonwn error: ${error['message']}`)
                                }
                            }
                        }
                    }}>
                        {"Import"}
                    </Button>
                    <Button onClick={closeSelf}>
                        {"Cancel"}
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    )
}